/**
 * WebSocket message types/schemas — matches ws.thrift contracts.
 * Uses IDL dot notation (canonical), not backend prose underscore naming.
 */

// ─── Event Types (Server → Client) ────────────────────────

export const WS_EVENT_TYPES = {
  TODO_CREATED: 'todo.created',
  TODO_UPDATED: 'todo.updated',
  NOTIFICATION_FIRED: 'notification.fired',
  STATE_SYNC: 'state_sync',
  PONG: 'pong',
  ERROR: 'error',
} as const;

// ─── Client → Server Messages ──────────────────────────────

export const WS_CLIENT_TYPES = {
  PING: 'ping',
  SUBSCRIBE: 'subscribe',
  UNSUBSCRIBE: 'unsubscribe',
  LAST_SEEN: 'last_seen',
} as const;

// ─── Message Shape ─────────────────────────────────────────

export interface WsMessage {
  type: string;
  data: unknown;
  meta?: {
    timestamp: string;
    request_id?: string;
  };
}

// ─── Payload Types ─────────────────────────────────────────

export interface TodoUpdatedPayload {
  id: string;
  changes: Record<string, unknown>;
  full_object: import('../types/domain').Todo;
}

export interface StateSyncPayload {
  todos: import('../types/domain').Todo[];
  household: import('../types/domain').Household;
  enabled_plugins: string[];
  connections_in_household: number;
}
